<template>
    <div class="cfWrapper px-s">   

      <div>
          <h3 class="pb-2xl font-rg">
            Upload your research submission form
          </h3>
      </div>

      <div :class="['hsLoading',formLoaded ? '':'visible']">
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
        <circle fill='#159DF3' stroke='#159DF3' stroke-width='15' r='15' cx='40' cy='100'>
          <animate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.4'></animate></circle><circle fill='#159DF3' stroke='#159DF3' stroke-width='15' r='15' cx='100' cy='100'><animate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.2'></animate></circle><circle fill='#159DF3' stroke='#159DF3' stroke-width='15' r='15' cx='160' cy='100'><animate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='0'></animate></circle></svg>
      </div> 

      <div :class="['hsWrapper',formLoaded ? 'visible':'']">
        <div class="formContainer hsFormReOp" ref="scriptContainer" id="hsFormReOp1"></div>
      </div>
    </div>
</template>

<style>
  .hsLoading
  {
    width: 100%;
    text-align: center;
  }
  .hsLoading svg
  {
    width: 100px;
    height: auto;
    margin: auto;
  }

  .hsLoading{display :none;}
  .hsLoading.visible{display: block;}
  .hsWrapper{display :none;}
  .hsWrapper.visible{display: block;}

  .content-opportunities ul 
  {
    padding-top: 5px;
    margin-left: 20px;
  }
  .hsFormReOp input
  {
    background: #fff !important;
  }
</style>

<style scoped>
  .cfWrapper
  {
    max-width: 700px;
  }
  .hsWrapper .hs-input:not([type=file])
  {
      background: #fcfdfd !important;

  }

</style>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      formLoaded:false
    };
  },
  mounted()
  {
    var vm=this;
    setTimeout(() => {
      vm.addForm();      
    }, 8000);
  },
  methods: {
    addForm()
    {
        /*
          hbspt.forms.create({
            region: "na1",
            portalId: "3835094",
            formId: "0a81222b-eb43-4931-b0bb-ec85e3ae5c26",
            target: "#hsFormReOp1"
          });*/

              if (window.hbspt && window.hbspt.forms) {
                  const scriptText = "hbspt.forms.create({portalId: '3835094',formId: '0a81222b-eb43-4931-b0bb-ec85e3ae5c26',region: 'na1'});";
                  const script = document.createElement('script')
                  script.innerHTML = scriptText;
                  this.$refs.scriptContainer.appendChild(script);
                  this.formLoaded = true;
              }else{
                  //wait until the hbspt script is loaded:
                    if(!this.formLoaded)
                    {
                        setTimeout(this.addForm, 500);
                    }
                    
              }

     }
  },
  computed: {
    //...mapGetters(["localeString"]),
  }
};
</script>





